/**
 * Sofortmeldung „die Signaturen haben sich geändert".
 *
 * Der Grund: Das Verfassen-Fenster lädt die Signaturliste EINMAL beim Öffnen.
 * Legt jemand über den neuen Dropdown-Eintrag „Signatur erstellen…" gerade
 * eben eine an, stünde das offene Fenster sonst weiter ohne sie da — der
 * frisch gegangene Weg bliebe folgenlos, und das Zurückkommen in die Mail
 * fühlte sich an, als wäre nichts passiert.
 *
 * `mailSignatureService` leert bei jedem Schreibvorgang bereits seinen Cache;
 * dieser Bus ist das fehlende Signal, dass sich ein erneutes Laden JETZT lohnt.
 * Modul-lokal statt `window`-Event (Vorbild: `mailAssignmentBus`), damit es im
 * Test ohne DOM benutzbar bleibt.
 */

type Hoerer = () => void;

const hoerer = new Set<Hoerer>();

export function meldeSignaturAenderung(): void {
    for (const h of Array.from(hoerer)) {
        try {
            h();
        } catch {
            /* ein defekter Hörer darf die anderen nicht mitreißen */
        }
    }
}

export function abonniereSignaturAenderung(fn: Hoerer): () => void {
    hoerer.add(fn);
    return () => {
        hoerer.delete(fn);
    };
}
